import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function erauReferenceValidator(): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (!value) return null;

    const erauRegex = /^ERAU\d{8}$/gi;

    if (erauRegex.test(value)) return null;

    return {
      eircode: true,
    };
  };
}
